/// <reference types="vite-plugin-svgr/client" />
import { Box, Container, Grid } from '@mui/material';
import { Outlet } from 'react-router-dom';

import GoLogo from '../assets/images/gymowners-logo-white.svg?react';
import BackgroundImage from '../assets/images/gymowners-background-black.svg';
import { useManageChat } from '~/modules/@shared/hooks/useManageChat';

function AuthLayout() {
  useManageChat({ close: true });

  return (
    <Box sx={{ backgroundColor: 'background.default' }}>
      <Grid container sx={{ minHeight: '100vh' }}>
        <Grid item xs={12} sm={6} sx={{ display: 'flex', justifyContent: 'center' }}>
          <Box
            sx={{
              maxWidth: {
                xs: 350,
                lg: 400,
              },
              display: 'flex',
              flexDirection: 'column',
              m: 'auto',
              justifyContent: { xs: 'center' },
              margin: { xs: '30px', sm: '20px' },
              paddingTop: { xs: 0, sm: '10px' },
              minHeight: { xs: '90vh' },
            }}>
            <Outlet />
          </Box>
        </Grid>
        {/* /Login form wrapper */}

        {/* Login image */}
        <Grid item xs={6}>
          <Box
            sx={{
              height: '100vh',
              backgroundColor: 'black',
              backgroundImage: `url(${BackgroundImage})`,
              backgroundSize: 'cover',
              display: {
                xs: 'none',
                sm: 'block',
              },
            }}>
            <Container
              sx={{
                maxWidth: { xs: 380 },
                px: { xs: 0 },
                height: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
                padding: { sm: '40px', md: '0' },
                backgroundColor: 'rgba(0, 0, 0, 0)',
              }}>
              <GoLogo />
            </Container>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}

export default AuthLayout;
